import { useReducer } from 'lib/hooks/useReducer';
import {
  initialState,
  QuestionnaireControlSliceReducer,
  questionnaireInfoInitialLoad
} from '../questionnaire-control-flow-slice';
import { useEffect } from 'react';
import { Collection } from 'lib/documents/document';

/**
 * Helper method to access data used for the questionnaire control component
 * @param patientId
 * @returns
 */
export function useControlFlowState(patientId: string) {
  const [questionnaireControlState, dispatch] = useReducer(
    QuestionnaireControlSliceReducer,
    initialState
  );
  useEffect(() => {
    dispatch(
      questionnaireInfoInitialLoad({
        patientId: patientId,
        rootPath: Collection.PendingPatientAssessments
      })
    );
  }, [patientId]);
  return questionnaireControlState;
}
